import { render, staticRenderFns } from "./comp_CustomizationFields-gender-name.vue?vue&type=template&id=ca2dc3e6&"
import script from "./comp_CustomizationFields-gender-name.vue?vue&type=script&lang=js&"
export * from "./comp_CustomizationFields-gender-name.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VItem } from 'vuetify/lib/components/VItemGroup';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
installComponents(component, {VItem,VItemGroup})
